import { render, staticRenderFns } from "./TooltipOnTruncateComponent.vue?vue&type=template&id=494005fd&scoped=true&"
import script from "./TooltipOnTruncateComponent.vue?vue&type=script&lang=ts&"
export * from "./TooltipOnTruncateComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494005fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
